<template>
    <div class="sf-loading" role="status" aria-label="Resultaten worden geladen">
        <div class="sf-loading__inner">
            <div class="sf-loading__avatar-wrap">
                <img
                    v-if="persona.imageUrl"
                    :src="persona.imageUrl"
                    :alt="persona.label"
                    class="sf-loading__avatar"
                />
                <div v-else class="sf-loading__avatar sf-loading__avatar--placeholder" aria-hidden="true"></div>
            </div>

            <p class="sf-loading__text">Even nadenken…</p>

            <div class="sf-loading__bar" aria-hidden="true">
                <div class="sf-loading__segment sf-loading__segment--yellow"></div>
                <div class="sf-loading__segment sf-loading__segment--taupe"></div>
                <div class="sf-loading__segment sf-loading__segment--yellow"></div>
                <div class="sf-loading__segment sf-loading__segment--taupe"></div>
            </div>

            <p class="sf-loading__sub">Ik zoek de beste tips voor jou in Hart van Limburg.</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LoadingScreen',

    props: {
        persona: {type: Object, required: true},
    },
};
</script>

<style lang="scss" scoped>
.sf-loading {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    min-height: 60vh;
    background-color: #f4ecdf;
    padding: 32px 16px;
    border-radius: 20px;
    margin: 2rem 0;

    &__inner {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        max-width: 300px;
        animation: sf-loading-in 0.45s cubic-bezier(0.16, 1, 0.3, 1) both;
    }

    &__avatar-wrap {
        margin-bottom: 24px;
        width: 84px;
        height: 84px;
    }

    &__avatar {
        width: 84px;
        height: 84px;
        border-radius: 50%;
        object-fit: cover;
        animation: sf-avatar-breathe 3s ease-in-out infinite;

        &--placeholder {
            background-color: #b5afa5;
            border-radius: 50%;
        }
    }

    &__text {
        font-family: 'Comfortaa', sans-serif;
        font-size: 20px;
        font-weight: 700;
        color: #23201e;
        margin: 0 0 24px;
    }

    &__bar {
        display: flex;
        gap: 4px;
        width: 200px;
        height: 8px;
        margin-bottom: 20px;
    }

    &__segment {
        flex: 1;
        border-radius: 4px;
        animation: sf-pulse 1.8s ease-in-out infinite;

        &--yellow {
            background: #e5bb5f;
        }

        &--taupe {
            background: #e8ddc9;
            animation-delay: 0.45s;
        }

        &:nth-child(3) {
            animation-delay: 0.9s;
        }

        &:nth-child(4) {
            animation-delay: 1.35s;
        }
    }

    &__sub {
        font-size: 14px;
        color: #23201e;
        opacity: 0.65;
        margin: 0;
        font-family: 'Comfortaa', sans-serif;
        line-height: 1.5;
    }
}

@keyframes sf-loading-in {
    from {
        opacity: 0;
        transform: translateY(16px) scale(0.96);
    }
    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

@keyframes sf-avatar-breathe {
    0%, 100% {
        transform: scale(1);
        box-shadow: 0 0 0 0 rgba(229, 187, 95, 0.4);
    }
    50% {
        transform: scale(1.04);
        box-shadow: 0 0 0 8px rgba(229, 187, 95, 0);
    }
}

@keyframes sf-pulse {
    0%, 100% {
        opacity: 0.4;
        transform: scaleX(0.85);
    }
    50% {
        opacity: 1;
        transform: scaleX(1);
    }
}
</style>
